<template>
  <div class="wrap">
    <van-nav-bar :title="$t('page.aboutus')">
      <van-icon slot="left" name="arrow-left" color="#fff" @click="$router.back()" />
    </van-nav-bar>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
import { NavBar, Icon, Toast } from "vant";
import { $post } from "../../utils/request";
export default {
  components: { [NavBar.name]: NavBar, [Icon.name]: Icon },
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.getContent();
  },
  methods: {
    async getContent() {
      Toast.loading();
      try {
        const res = await $post("/other/config", { act: "about" });
        const { ret, msg, data } = res.data;
        Toast.clear();
        if (ret === 1) {
          const about = typeof data === "string" ? data : data && data.about;
          this.content = typeof about === "string" ? about : "";
          return
        }
        Toast(msg)
      } catch (error) {
        Toast.clear();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background: #fff;
}

.content {
  padding: calc(14rem / 16);

  /deep/ a {
    color: var(--color-primary-strong);
    word-break: break-all;
  }

  /deep/ img {
    width: 100%;
    height: 100%;
  }
}
</style>
